import request from "@/utils/request";
import { IEviMembercertinfo } from "../model/evimembercertinfo";

// 实体
export const defaultEviMembercertinfoData: IEviMembercertinfo = {
  id: "",
  memberId: "",
  memberType: 0,
  certType: 0,
  certUserName: "",
  certUserAdditionalField: "",
  certIssueTime: 0,
  certExpireTime: 0,
  certOrg: "",
  certSignatureAlgorithm: "",
  certSerialNumber: "",
  certSignBuf: "",
  accountAddress: "",
  accountPublicKey: "",
  accountPrivateKey: "",
  createTime: 0,
  updateTime: 0,
  certStatus: 0,
  signStatus: 0,
  certUrl: "",
  certPasswd: "",
  orderId: ""
};

export const getEviMembercertinfo = (id: any) => {
  request({
    url: "/EviMembercertinfo/Get",
    method: "post",
    params: { id: id }
  });
};

export const addEviMembercertinfo = (data: any) =>
  request({
    url: "/EviMembercertinfo/Add",
    method: "post",
    data
  });

export const updateEviMembercertinfo = (data: any) =>
  request({
    url: "/EviMembercertinfo/Update",
    method: "post",
    data
  });

export const deleteEviMembercertinfo = (id: string) =>
  request({
    url: "/EviMembercertinfo/Delete",
    method: "post",
    params: { id: id }
  });

export const getEviMembercertinfoPageList = (data: any) =>
  request({
    url: "/EviMembercertinfo/GetPageListAsync",
    method: "post",
    data
  });

export const privateSecretValid = (data: any) =>
  request({
    url: "/EviMembercertinfo/PrivateSecretValid",
    method: "post",
    data
  });

export const certificationPayCode = (data: any) =>
  request({
    url: "/EviMembercertinfo/CertificationPayCode",
    method: "post",
    data
  });

export const certApply = (data: any) =>
  request({
    url: "/EviMembercertinfo/CertApply",
    method: "post",
    data
  });
